<template>
  <div class="order-search-panel">
    <div class="filters d-flex flex-wrap">
      <template v-for="filter in orderFilters">
        <select-label-wrapper
          :key="filter.id"
          :label="filter.label"
          :style="{ minWidth: filter.width }"
          class="mr-2"
        >
          <gx-date-range-select
            v-if="filter.id === 'date_range'"
            :date-range.sync="filterModels[filter.id]"
            :disabled="isLoading"
            show-date-range
            @selectedDateRange="handleSelectedDateRange"
          />

          <el-input
            v-else-if="filter.id === 'order_number'"
            v-model="filterModels[filter.id]"
            :disabled="isLoading"
          />

          <el-select
            v-else
            v-model="filterModels[filter.id]"
            :loading="isLoading || filter.isLoading"
            filterable
          >
            <el-option
              v-for="item in filter.list || []"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </select-label-wrapper>
      </template>
    </div>

    <div class="d-flex justify-content-flex-end mr-2">
      <!-- <el-button
        :disabled="isLoading"
        type="info"
        @click="handleClickSearch"
      >{{ $t('button.search') }}</el-button> -->
      <el-button
        :disabled="isLoading"
        type="info"
        @click="handleClickGenerateCSV"
      >{{ $t('button.generateCSV') }}</el-button>
    </div>
  </div>
</template>

<script>
import { createComponent, reactive, ref, onMounted } from '@vue/composition-api'
import format from 'date-fns/format'

import SelectLabelWrapper from '../../../components/form/LabelWrapper.vue'

import { getOrderFilters } from '../../../const/order'

const OrderSearchPanel = createComponent({
  components: { SelectLabelWrapper },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { root, emit }) {
    // filter models
    const orderFilters = reactive(getOrderFilters())
    const filterModels = reactive(orderFilters.reduce((accu, curr) => {
      accu[curr.id] = curr.default
      return accu
    }, {}))

    // return filters for parent components
    const customDateRange = ref(null)
    const getSearchObject = () => {
      const searchObject = { ...filterModels }
      delete searchObject.date_range;
      [searchObject.start_date, searchObject.end_date] =
        customDateRange.value.map(date => format(date, 'yyyy-MM-dd'))
      return searchObject
    }
    const handleClickSearch = () => {
      emit('search', getSearchObject())
    }
    const handleClickGenerateCSV = () => {
      emit('generateCSV', getSearchObject())
    }

    const handleSelectedDateRange = (range) => {
      customDateRange.value = range
    }

    onMounted(() => {
      // fetch order filter list (merchants, currency, country)
      orderFilters.forEach(async (filter) => {
        if (filter.fetchList) {
          filter.isLoading = true
          // fetch filter option lists
          const lst = await filter.fetchList()
          root.$set(filter, 'list', lst)
          filter.isLoading = false
        }
      })
    })

    return {
      filterModels,
      orderFilters,

      // handlers
      handleClickSearch,
      handleClickGenerateCSV,
      handleSelectedDateRange,
    }
  },
})

export default OrderSearchPanel
</script>

<style lang="scss" scoped>
.order-search-panel {
  background: #f6f6f6;
  margin: 0 -20px;
  padding: 16px 24px;
}
</style>
